import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
import { defineComponent, onMounted, ref, reactive, watch } from 'vue';
import { debounce } from '../../lib/common';
export default defineComponent({
  props: {
    modelValue: {},
    title: {
      default: '- izberi -'
    },
    disabled: {
      default: false
    },
    readonly: {
      default: false
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hasGroups: {
      default: false
    }
  },
  emits: ['update:modelValue', 'itm-change'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var txt = ref();
    var list = ref();
    var items = ref();
    var btn = ref();
    var state = reactive({
      showList: false,
      visibleData: props.data,
      selectedItem: null,
      selectedIndex: 0
    });

    var selectItem = function selectItem(itm, index) {
      state.selectedIndex = index;
      state.selectedItem = itm;
      state.showList = false;
      state.visibleData = props.data;
      txt.value = null;
    };

    var itemClick = function itemClick(itm, index) {
      selectItem(itm, index);
      emit('update:modelValue', itm.id);
      emit('itm-change', itm);
      setTimeout(function () {
        return btn.value.focus();
      }, 10);
    };

    var selectValue = function selectValue() {
      var f = props.data.findIndex(function (x) {
        return x.id === props.modelValue;
      });
      var itm = {
        id: null,
        text: props.title
      };

      if (f > -1) {
        itm = props.data[f];
      }

      selectItem(itm, f);
    };

    var setItemScrollFocus = function setItemScrollFocus() {
      var itms = items.value;

      if (itms && itms.length > 0) {
        var li = itms[state.selectedIndex];
        list.value.scrollTop = li.offsetTop - 60;
      }
    };

    var focus = function focus() {
      if (state.selectedItem) {
        setItemScrollFocus();
      }

      state.showList = true;
      setTimeout(function () {
        return txt.value.focus();
      }, 10);
    };

    var toggle = function toggle() {
      if (props.disabled || props.readonly) {
        return;
      }

      state.showList = !state.showList;

      if (state.showList) {
        focus();
      }
    };

    var getText = function getText(itm, r) {
      if (itm) {
        var _txt = itm.text;
        return r && _txt ? _txt.replace(/&nbsp;/g, '') : _txt;
      }
    };

    var reset = function reset() {
      state.showList = false;
      txt.value.value = null;
      state.visibleData = props.data;
      setTimeout(function () {
        return btn.value.focus();
      }, 10);
    };

    var keyDownBtn = function keyDownBtn() {
      if (props.disabled || props.readonly) {
        return;
      }

      focus();
    };

    var keyDownBtnDelete = function keyDownBtnDelete() {
      if (!props.disabled && !props.readonly) {
        emit('update:modelValue', null);
      }
    };

    var keyDown = function keyDown() {
      focus();

      if (state.selectedIndex < state.visibleData.length - 1) {
        state.selectedIndex++;
        setItemScrollFocus();
      }
    };

    var keyUp = function keyUp() {
      focus();

      if (state.selectedIndex > 0) {
        state.selectedIndex--;
        setItemScrollFocus();
      }
    };

    var keyEnter = function keyEnter() {
      itemClick(state.visibleData[state.selectedIndex], state.selectedIndex);
    };

    var input = debounce(function (v) {
      state.selectedIndex = 0;
      state.visibleData = props.data.filter(function (x) {
        return getText(x, null).toLowerCase().indexOf(v.toLowerCase()) >= 0;
      });
    }, 300);
    watch(function () {
      return props.data;
    }, function (val, prevVal) {
      state.visibleData = val;
      selectValue();
    });
    watch(function () {
      return props.modelValue;
    }, function (val, prevVal) {
      selectValue();
    });
    onMounted(function () {
      selectValue();
    });
    return {
      state: state,
      itemClick: itemClick,
      focus: focus,
      toggle: toggle,
      getText: getText,
      reset: reset,
      keyDownBtn: keyDownBtn,
      keyDownBtnDelete: keyDownBtnDelete,
      keyDown: keyDown,
      keyUp: keyUp,
      keyEnter: keyEnter,
      input: input,
      btn: btn,
      txt: txt,
      list: list,
      items: items
    };
  }
});